"use client";

import { cn } from "@/lib/utils";
import React from "react";
import { Button } from "../button";
import { Icon } from "../icon";

export function ScrollButton() {
  const [visible, setVisible] = React.useState(false);
  const [atBottom, setAtBottom] = React.useState(false);

  React.useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 300);
      const viewportHeight = document.documentElement.clientHeight;
      const scrolledToBottom =
        Math.ceil(viewportHeight + window.scrollY) >=
        Math.ceil(document.documentElement.scrollHeight) - 20;
      setAtBottom(scrolledToBottom);
    };

    window.addEventListener("scroll", toggleVisibility);
    window.addEventListener("resize", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
      window.removeEventListener("resize", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <Button
      onClick={scrollToTop}
      className={cn(
        "fixed",
        "right-6",
        "shadow-lg",
        "z-50",
        "opacity-0",
        "transition-all",
        "duration-300",
        "h-13",
        "pointer-events-none",
        visible && "opacity-100 pointer-events-auto",
        atBottom ? "bottom-88 lg:bottom-40 xl:bottom-34" : "bottom-6",
      )}
      aria-label="Voltar ao topo"
    >
      Voltar ao topo <Icon icon="FaAngleUp" />
    </Button>
  );
}
